import { DeleteOutlined, DownOutlined, EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons'
import { ConfigProvider, Pagination, PaginationProps, Select, TreeSelect } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import '../../CampaignSendsNotifications.scss'

import viVN from 'antd/locale/vi_VN'
import '../../../../../components/ExportImgFigma'

import { ColDef } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { NodataTable } from '../../../../../components/NoDataTable'
import { formatNumber } from '../../../../../services/mixin'
import { dataPagination, getLastIdList, getWidthFromHeader, renderValueAsJSX } from '../../../../../until'
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { ISelectedCustomer } from '../../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import '../../CampaignSendsNotifications.scss'
import { IDataFilterGroupList, InfoCampaignTmp, useCustomerGroupContext } from '../../Create'
import { getListLogCustomerOfCampaign, ILogCustomerOfCampaign, resendCampaign } from '../../../../../api/campaign/campaignApi'
import { NO_VIEW } from '../../../../../services/data'
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone'
import { ICustomerFields } from '../../../../../api/salesSericeCustomer/salesSericeCustomerApi'
import { channels, SendTimeType } from '../../Create/Component/InfoCreate'
import { Auto_Icon, ZNS } from '../../../../../components/ExportImgFigma'
import "../styles.scss"
import useToast from '../../../../../hook/useToast'
import useLoading from '../../../../../hook/useLoading'
import useThrottle from '../../../../../hook/useThrottle'

export const generateColumnsFromCodesAgGridReactGroup = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>[],
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
): ColDef[] => {
    const baseColumns = codes
        .filter(code => !actionColumn?.some(c => c.field === code))
        .map(code => {
            const field = fields.find(f => f.fieldCode === code);
            if (!field) return null;

            return {
                headerName: field.fieldLabel,
                field: field.fieldCode,
                colId: field.fieldCode,
                sortable: true,
                width: getWidthFromHeader(field.fieldLabel),
                cellRenderer: (params: any) => {
                    const value = params.value;

                    if (field.fieldCode === "cus_name") {
                        return (
                            <span
                                style={{ cursor: "pointer", color: "#096DD9" }}
                                onClick={() => onToggleStatus?.(params.data?.id, true, params)}
                            >
                                {renderValueAsJSX(value, field.fieldCode)}
                            </span>
                        );
                    }

                    return renderValueAsJSX(value,field.fieldCode);
                }
            } as ColDef;
        })
        .filter(Boolean) as ColDef[];


    return actionColumn ? [...actionColumn, ...baseColumns] : baseColumns;
};

interface props {
    id: number

    infoCampaign?: InfoCampaignTmp

    selectedIdCustomer: ISelectedCustomer[]


}

const TableLogDetail: React.FC<props> = ({
    id, infoCampaign,
    selectedIdCustomer,
}) => {

    useEffect(() => {
        gListLogCustomerOfCampaign()
    }, [])

    const pushToast = useToast()
    const pushLoading = useLoading()

    const { ColumnsMapShow, dataFieldsActive } = useCustomerGroupContext()

    const [paginationLog, setPaginationLog] = useState({ current: 1, pageSize: 30, total: 0 });

    const [infoLog, setInfoLog] = useState<ILogCustomerOfCampaign>()
    const [idLast, setIdLast] = useState<number>();

    const actionColumn: ColDef[] = [
        {
            headerName: 'Trạng thái',
            field: 'campaign_status',
            colId: 'campaign_status',
            width: 180,
            resizable: false,
            suppressMovable: true,
            lockPosition: 'left',
            headerComponentParams: {
                template: '<span class="w-full flex items-center justify-center">Trạng thái</span>'
            },
            cellRenderer: (params: any) => {
                const isSuccess = !!params.value;

                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            height: '100%',
                        }}
                    >
                        <span
                            style={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: isSuccess ? '#52C41A' : '#FF4D4F',
                                display: 'inline-block',
                            }}
                        />
                        <span>
                            {isSuccess ? 'Thành công' : 'Thất bại'}
                        </span>
                    </div>
                )
            },
        },
        {
            headerName: 'Kênh gửi',
            field: 'campaign_channelId',
            colId: 'campaign_channelId',
            width: 180,
            resizable: false,
            suppressMovable: true,
            lockPosition: 'left',
            headerComponentParams: {
                template: '<span class="w-full flex items-center justify-center">Kênh gửi</span>'
            },
            cellRenderer: (params: any) => {
                return (
                    <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
                        <img
                            src={channels[params.data.campaign_channelId - 1].icon} alt=""
                            onError={(e) => {
                                e.currentTarget.src = ZNS;
                            }}
                        />
                    </div>

                )
            },
        },
    ]

    const tableData = useMemo<any[]>(() => {
        if (!infoLog?.dataList?.length) return [];

        return infoLog.dataList.map(item => {
            const fieldValues = item.fields.reduce(
                (acc: Record<string, any>, field) => {
                    acc[field.fieldCode] = field.view ? field.value : NO_VIEW;
                    return acc;
                },
                {}
            );

            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            };
        });
    }, [infoLog?.dataList]);

    const memoizedColumnDefs = useMemo(() => {
        return generateColumnsFromCodesAgGridReactGroup(
            ColumnsMapShow, dataFieldsActive, actionColumn
        );
    }, [ColumnsMapShow, tableData]);

    const gListLogCustomerOfCampaign = async (pageCurent: number = 1, pageSize: number = 20) => {

        const lastIdTmp = pageCurent === 1 ? undefined : idLast
        pushLoading(true)
        const result = await getListLogCustomerOfCampaign(
            id,
            pageSize, lastIdTmp
        )
        if (result.status) {
            setInfoLog(result.data)
            setPaginationLog({ current: pageCurent, total: result.data.total, pageSize })

            setIdLast(getLastIdList(result.data.dataList))
        }
        pushLoading(false)
    }

    const rCampaign = useThrottle(async (pageCurent: number = 1, pageSize: number = 20) => {

        pushLoading(true)

        const result = await resendCampaign(
            id,
        )
        if (result?.status) {
            pushToast(result?.message, 'success')
        } else {
            pushToast(result?.message, 'error')
        }
        pushLoading(false)
    }, 5000)


    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        console.log(pageNumber);

        gListLogCustomerOfCampaign(pageNumber, pageSize)
    }

    const checkIsResend = () => {
        const { role, dateSend, timeSend } = infoCampaign ?? {}
        let isSend = false
        if (role === SendTimeType.NOW) {
            isSend = !!infoLog?.totalFail
        } else {
            isSend = !!infoLog?.totalFail
        }
        return isSend ? "" : "d-none"
    }

    return (
        <div className="custom-page-css  w-full flex flex-col  gap-3">

            <div className="custom-page-css flex gap-4 ">
                <div className="custom-page-css flex flex-col gap-5 flex-1 border-1890FF rounded px-6 py-2 relative ">
                    <div className="custom-page-css text-667085 text-base font-medium">Tổng số lượng đã gửi</div>
                    <div className="custom-page-css text-344054 text-lg font-medium">{formatNumber(infoLog?.total ?? 0)}</div>
                    <div className="custom-page-css absolute b-0 r-0 ">
                        <img src={Auto_Icon} alt="" />
                    </div>
                </div>

                <div className="custom-page-css flex flex-col gap-5 flex-1 border-F59C23 rounded px-6 py-2 relative ">
                    <div className="custom-page-css text-667085 text-base font-medium">Gửi thành công</div>
                    <div className="custom-page-css text-344054 text-lg font-medium">{formatNumber(infoLog?.totalSuccess ?? 0)}</div>
                    <div className="custom-page-css absolute b-0 r-0 ">
                        <img src={Auto_Icon} alt="" />
                    </div>
                </div>

                <div className="custom-page-css flex flex-col gap-5 flex-1 border-1890FF rounded px-6 py-2 relative ">
                    <span className="custom-page-css text-667085 text-base font-medium">Gửi thất bại</span>
                    <div className="summary-footer custom-page-css z-10">
                        <span className="custom-page-css text-344054 text-lg font-medium">{formatNumber(infoLog?.totalFail ?? 0)}</span>

                        <button
                            className={`retry-btn ${checkIsResend()}`}
                            onClick={rCampaign}
                        >
                            Gửi lại
                        </button>
                    </div>
                    <div className="custom-page-css absolute b-0 r-0 ">
                        <img src={Auto_Icon} alt="" />
                    </div>

                </div>
            </div>

            {/* <span className="custom-page-css flex-2 text-344054 font-bold text-base">Danh sách khách hàng</span> */}

            <div className="custom-page-css w-full flex flex-col   gap-3">
                <div className="custom-page-css flex items- gap-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatNumber(paginationLog.total)} tin nhắn</span>
                </div>
            </div>
            <div className="ag-theme-alpine custom-table-ag custom-h-modal" style={{ height: 550, width: '100%' }}>
                <AgGridReact
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    columnDefs={memoizedColumnDefs}
                    rowData={tableData}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}
                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={paginationLog.current}
                        pageSize={paginationLog.pageSize}
                        total={paginationLog.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(paginationLog.total, paginationLog.pageSize, paginationLog.current).totalPage} trang`}
                        className='rs-pagination'
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>
        </div>
    )
}


export default TableLogDetail